module.exports = __webpack_public_path__ + "img/u586.2dbc28e3.svg";